import { render, staticRenderFns } from "./message-template.vue?vue&type=template&id=dbbf0138"
import script from "./message-template.vue?vue&type=script&lang=js"
export * from "./message-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports